import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3120, { U3120ROLES } from "./U3120";
import U3120CustomerList from "./components/U3120CustomerList";
import U3120CustomerForm from "./components/U3120CustomerForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3120Routes: RouteObject[] = [
  {
    path: "U3120",
    element: <U2000RequireRole allowedRoles={[U3120ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3120 />,
        children: [
          { index: true, element: <U3120CustomerList /> },
          { path: ":id", element: <U3120CustomerForm /> },
        ],
      },
    ],
  },
];

export default U3120Routes;
